module.exports = __webpack_public_path__ + "static/media/trumpetCorrect.1301ca99.png";